export default class UsersDataProvider {
  constructor(Users) {
    "ngInject"
    this.UsersService = Users;
  }

  getUsers(data) {
    return this.UsersService.loadUsers(data)
      .then((result) => {
        return result;
      })
  }

  getUser(id) {
    return this.UsersService.getUser(id)
      .then((result) => {
        return result;
      })
  }

  getOrders(data) {
    return this.UsersService.getOrders(data)
      .then((result) => {
        return result;
      })
  }

  getComments(id) {
    return this.UsersService
      .getComments(id)
      .then((resp) => {
        return resp;
      })
  }

  saveComments(data) {
    return this.UsersService
      .saveComments(data)
      .then((resp) => {
        return resp;
      })
  }

  removeComment(id) {
    return this.UsersService
      .removeComment(id)
      .then((resp) => {
        return resp;
      })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/services/user.dataprovider.service.js
 **/